var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Tooltip',{staticClass:"ivu-table-cell-tooltip",attrs:{"transfer":"","content":_vm.labeltext,"disabled":!_vm.showTooltip,"max-width":_vm.maxWidth}},[_c('span',{ref:"content",staticClass:"ivu-table-cell-tooltip-content",style:('text-align:'+ _vm.contentAlign),domProps:{"innerHTML":_vm._s(_vm.showText)},on:{"mouseenter":_vm.handleTooltipIn,"mouseleave":_vm.handleTooltipOut}})])}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/label/showtext.vue